import _toConsumableArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";

/**
 * @file Created on Thu Aug 09 2018
 * @author VBr
 */
import * as React from 'react';
import { T } from '../../i18n/T';
import StyledTable from './styled/StyledTable';
export var Table =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Table, _React$Component);

  function Table(props) {
    var _this;

    _classCallCheck(this, Table);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Table).call(this, props));
    _this.getColumns = _this.getColumns.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.getRow = _this.getRow.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.state = {
      activeCell: ''
    };
    return _this;
  }

  _createClass(Table, [{
    key: "render",
    value: function render() {
      return React.createElement(StyledTable, Object.assign({}, this.props), React.createElement("table", null, React.createElement("thead", {
        className: "droppable-area"
      }, this.getColumns(this.props.columns)), React.createElement("tbody", {
        className: "droppable-area"
      }, this.getRow())));
    }
  }, {
    key: "getColSpan",
    value: function getColSpan(column) {
      var _this2 = this;

      var count = 1;

      if (column.columns !== undefined) {
        count = column.columns.length;
        column.columns.forEach(function (col) {
          if (col.columns !== undefined) {
            count += _this2.getColSpan(col.columns);
          }
        });
      }

      return count;
    }
  }, {
    key: "getRowSpan",
    value: function getRowSpan(columns) {
      var _this3 = this;

      var count = 0;
      var nested = columns.filter(function (column) {
        return column.columns !== undefined;
      });

      if (nested.length !== 0) {
        count = 1;
      }

      nested.forEach(function (column) {
        count += _this3.getRowSpan(column.columns);
      });
      return count;
    }
  }, {
    key: "getColumns",
    value: function getColumns(columns) {
      var _this4 = this;

      if (!columns.length) {
        return null;
      }

      var subcolumns = [];
      var rowSpan = this.getRowSpan(columns) + 1;
      return React.createElement(React.Fragment, null, React.createElement("tr", null, columns.map(function (col, i) {
        var cols = col.columns || [];

        var colSpan = _this4.getColSpan(col);

        subcolumns = [].concat(_toConsumableArray(subcolumns), _toConsumableArray(cols));
        return React.createElement("th", {
          colSpan: colSpan,
          rowSpan: cols.length !== 0 ? 1 : rowSpan,
          key: col.dataIndex
        }, React.createElement(T, {
          id: col.title
        }));
      })), this.getColumns(subcolumns));
    }
  }, {
    key: "getRow",
    value: function getRow() {
      var _this5 = this;

      return this.props.data.map(function (row, i) {
        return React.createElement("tr", {
          key: i
        }, _this5.props.columns.map(function (col, k) {
          return _this5.getCell(i, row, col);
        }));
      });
    }
  }, {
    key: "getCell",
    value: function getCell(index, row, column) {
      var _this6 = this;

      var colSpan = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

      if (column.columns) {
        return column.columns.map(function (col) {
          return _this6.getCell(index, row, col, _this6.getColSpan(column.columns) + 1);
        });
      } else {
        return React.createElement("td", {
          key: column.dataIndex
        }, row[column.dataIndex]);
      }
    }
  }]);

  return Table;
}(React.Component);